export const EVENT_TYPE_DATA = [
    { name: "Bachelor/Bachelorette Party", value: "bachelor" },
    { name: "Birthday", value: "birthday" },
    { name: "Bridal Shower", value: "bridal" },
    { name: "Company Event", value: "company" },
    { name: "Graduation", value: "grad" },
    { name: "House Warming", value: "house_warming" },
    { name: "Open House", value: "open_house" },
    { name: "Other", value: "other" },
    { name: "Wedding", value: "wedding" },
  ];
  
  export const COCKTAILS_TYPES_DATA = [
    { name: "Aperol", value: "aperol" },
    { name: "Beer Cocktail", value: "beer_cocktail" },
    { name: "Cognac", value: "cognac" },
    { name: "Gin", value: "gin" },
    { name: "Liqueur", value: "liqueur" },
    { name: "Mezcal", value: "mezcal" },
    { name: "Rum", value: "rum" },
    { name: "Rum Dark", value: "rum_dark" },
    { name: "Pisco", value: "pisco" },
    { name: "Prosecco", value: "prosecco" },
    { name: "Sparkling", value: "sparkling" },
    { name: "Sparkling Rose", value: "sparkling_rose" },
    { name: "Tequila", value: "tequila" },
    { name: "Vermouth", value: "vermouth" },
    { name: "Vodka", value: "vodka" },
    { name: "Whisky", value: "whisky" },
    { name: "Beer", value: "beer" },
    { name: "Red Wine", value: "red_wine" },
    { name: "Seltzer", value: "seltzer" },
    { name: "Water", value: "water" },
    { name: "White Wine", value: "white_wine" },
  ];